import script from "./AddGroupModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddGroupModal.vue?vue&type=script&setup=true&lang=js"

import "./AddGroupModal.vue?vue&type=style&index=0&id=a37e0c06&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a37e0c06"]])

export default __exports__